/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { ILayout } from "@/interfaces/layout/ILayout";

export const ui = {
  state: {
    layout: "main-layout",
    drawer: false,
    cardMode: true,
  },
  mutations: {
    SET_LAYOUT(state: IState, newLayout: any) {
      state.layout = newLayout;
    },
    UPDATE_DRAWER(state: IState, payload: any) {
      state.drawer = payload;
    },
    TOGGLE_LIST_MODE(state: IState) {
      state.cardMode = !state.cardMode;
    },
  },
  actions: {
    setLayout(context: any, payload: ILayout) {
      context.commit("SET_LAYOUT", payload);
    },
    toggleDrawer(context: any, payload: any) {
      context.commit("UPDATE_DRAWER", payload);
    },
    toggleListMode(context: any) {
      context.commit("TOGGLE_LIST_MODE");
    },
  },
  getters: {
    getLayout(state: IState) {
      return state.layout;
    },
    getDrawer(state: IState) {
      return state.drawer;
    },
    getCardMode(state: IState) {
      return state.cardMode;
    },
  },
};
